import { InspectionStatusType } from './InspectionStatusType';

export const InspectionStatusTypeOptions = [
    {
        id: InspectionStatusType.New,
        name: 'Awaiting Granite Project Creation',
    },
    {
        id: InspectionStatusType.AwaitingProjectActivation,
        name: 'Awaiting Granite Project Activation',
    },
    {
        id: InspectionStatusType.ProjectActivated,
        name: 'Project Activated by Granite',
    },
    {
        id: InspectionStatusType.InspectionCreated,
        name: 'Inspection submitted to Granite',
    },
    {
        id: InspectionStatusType.InspectionPending,
        name: 'Pending processing by Granite',
    },
    {
        id: InspectionStatusType.InspectionInProgress,
        name: 'In Progress',
    },
    {
        id: InspectionStatusType.InspectionDelivered,
        name: 'Completed/Delivered',
    },
    {
        id: InspectionStatusType.GraniteInternalStatus,
        name: 'Internal Granite Status. Awaiting update...',
    },
    {
        id: InspectionStatusType.Error,
        name: 'Error',
    },
    {
        id: InspectionStatusType.ResetRequested,
        name: 'Pending Error Reset',
    },
];
